import { createGlobalStyle } from 'styled-components'
import theme from './theme'

export default createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }
  html {
    font-family: sans-serif;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html, body {
    width: 100%;
    height: 100%;
  }
  body {
    margin: 0;
    font-family: ${`"${theme.primaryFontFamily}", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`};
    font-size: ${theme.primaryFontSize};
    font-weight: ${theme.primaryFontWeight};
    line-height: ${theme.primaryLineHeight};
    color: #2b3a4d;
    background-color: #f4f6fa;
  }

  /* ---- Modernização visual (2026-07): campos, menu e barras de rolagem ---- */

  input:not([type='checkbox']):not([type='radio']):not(.inputfile),
  select,
  textarea {
    border: 1px solid #dfe6ef;
    border-radius: 10px;
    padding: 10px 12px;
    font-family: inherit;
    font-size: 14px;
    color: #26364a;
    background-color: #fff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  input:not([type='checkbox']):not([type='radio']):not(.inputfile):focus,
  select:focus,
  textarea:focus {
    outline: none;
    border-color: hsla(199, 75%, 57%, 1);
    box-shadow: 0 0 0 3px rgba(63, 175, 228, 0.16);
  }

  ::placeholder { color: #a9b8ca; }

  ::-webkit-scrollbar { width: 10px; height: 10px; }
  ::-webkit-scrollbar-thumb { background: #d7dfea; border-radius: 8px; border: 2px solid transparent; background-clip: content-box; }
  ::-webkit-scrollbar-thumb:hover { background: #c3cede; background-clip: content-box; }
  ::-webkit-scrollbar-track { background: transparent; }
  div {
    -webkit-overflow-scrolling: touch;
  }
  a {
    text-decoration: none;
  }

  input{
    width: 100%
  }

  .menulink {
    display: block;
    margin: 3px 10px;
    border-radius: 10px;
    font-size: 14px;
    transition: background-color 0.15s ease, transform 0.1s ease;
    &:hover {
      background-color: rgba(255, 255, 255, 0.16);
    }
    &.active {
      background-color: rgba(255, 255, 255, 0.24);
      font-weight: 600;
      box-shadow: inset 3px 0 0 rgba(255, 255, 255, 0.9);
    }
  }

  button {
    font-family: Montserrat !important;
  }




  .simple-react-notifier {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  pointer-events: none;
  padding: 16px;
}

.simple-react-notifier > * {
  pointer-events: initial;
  animation-fill-mode: forwards;
}

.simple-react-notifier.top-left {
  left: 0;
  right: auto;
}

.simple-react-notifier.top-center {
  left: 50%;
  transform: translate(-50%, 0);
  right: auto;
}

.simple-react-notifier.bottom-left {
  top: auto;
  right: auto;
  left: 0;
  bottom: 0;
}

.simple-react-notifier.bottom-center {
  top: auto;
  left: 50%;
  transform: translate(-50%, 0);
  right: auto;
  bottom: 0;
}

.simple-react-notifier.bottom-right {
  top: auto;
  bottom: 0;
}

.simple-react-notifier .item {
  position: relative;
  min-height: 48px;
  margin-bottom: 16px;
  padding: 14px 6px;
  border-radius: 4px;
  box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: flex-start;
  cursor: default;
  font-size: 14px;
  line-height: 1.3;
  color: white;
}

.simple-react-notifier .item span {
  margin: 0 20px 0 10px;
}

.simple-react-notifier .item button {
  cursor: pointer;
  color: white;
  background: transparent;
  border: 0;
  position: relative;
  top: -5px;
}

.simple-react-notifier .item.success {
  background: #28a745;
  border-left: 8px solid #1e7532;
}

.simple-react-notifier .item.info {
  background: #077bf7;
  border-left: 8px solid #055fbe;
}

.simple-react-notifier .item.error {
  background: #e23849;
  border-left: 8px solid #ac1f2d;
}

.simple-react-notifier .item.rtl {
  direction: rtl;
  border-left: 0;
}

.simple-react-notifier .item.rtl.success {
  border-right: 8px solid #1e7532;
}

.simple-react-notifier .item.rtl.info {
  border-right: 8px solid #055fbe;
}

.simple-react-notifier .item.rtl.error {
  border-right: 8px solid #ac1f2d;
}

.simple-react-notifier .item button {
  display: none !important;
}

.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.inputfile + label {
  font-weight: 400;
  padding: 8px;
  color: white;
  background-color: hsla(199,75%,57%,1);
  display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
  background-color: hsla(199,56%,41%,1);
}

.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}

.inputfile:focus + label {
	outline: 1px dotted #000;
	outline: -webkit-focus-ring-color auto 5px;
}
`
